import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";

// Only coalesce concurrent requests; reopening a page must read current configuration.
const pending = new Map();

export function hasCostPermission(value, roleId) {
	if (!roleId || !value) return false;
	let roles = value;
	if (typeof roles === "string") {
		try {
			roles = JSON.parse(roles);
		} catch {
			roles = roles.split(/[,;|\s，；]+/);
		}
	}
	if (!Array.isArray(roles)) roles = [roles];
	return roles.some((role) => typeof role === "string" && role.trim() === roleId);
}

function session() {
	try {
		const user = JSON.parse(localStorage.getItem("userdata"));
		const roleId = user && user.roleInfo && user.roleInfo.keyId;
		return { roleId, key: localStorage.getItem("logintoken") + ":" + localStorage.getItem("userdata") };
	} catch {
		return {};
	}
}

export default {
	data() {
		return { canSeeCost: false };
	},
	created() {
		this.refreshCostPermission();
		["showDialog", "dialogVisible", "showDetailVisible", "dialogEditKDNoVisible"].forEach((key) => {
			if (Object.prototype.hasOwnProperty.call(this.$data, key)) {
				this.$watch(key, (visible) => {
					if (visible) this.refreshCostPermission();
				});
			}
		});
	},
	activated() {
		this.refreshCostPermission();
	},
	watch: {
		$route() {
			this.refreshCostPermission();
		}
	},
	methods: {
		async refreshCostPermission() {
			this.canSeeCost = false;
			const current = session();
			const requestId = (this._costPermissionRequestId || 0) + 1;
			this._costPermissionRequestId = requestId;
			if (!current.roleId) return;
			if (!pending.has(current.key)) {
				const request = Promise.resolve()
					.then(() => GetSystemBusinessConfigDetailByCode({ code: "SeeAllData" }))
					.then((res) => res && res.code == 1 && res.data ? res.data.value : null)
					.catch(() => null)
					.finally(() => pending.delete(current.key));
				pending.set(current.key, request);
			}
			const value = await pending.get(current.key);
			if (requestId === this._costPermissionRequestId && session().key === current.key) {
				this.canSeeCost = hasCostPermission(value, current.roleId);
			}
		},
		costVisibleColumns(columns) {
			return columns.filter((column) => !column.requiresSeeAllData || this.canSeeCost);
		}
	}
};
